import './App.css';
import {Routes,Route} from "react-router"
import Home from "./Component/Pages/Home"
import Login from './Component/Pages/Login';
import MyProfile from './Component/Pages/MyProfile';
import { Provider } from 'react-redux';
import { Toaster } from 'sonner';
import store from './redux/store';
import BusBooking from './Component/Pages/BusBooking';
import Payment from './Component/Pages/Payment';
import Privacy_policy from './Component/Pages/privacy_policy';
import Termscondition from './Component/Pages/termscondition';
import Tickit from './Component/Pages/Tickit';
import BusDetails from './Component/Pages/BusDetails';

function App() {
  return (
    <div>
      <Provider store={store}>
           <Toaster   position="bottom-right"
        theme="dark"           // 👈 Forces dark mode (always readable)
        richColors             // 👈 Adds nice gradients and contrast
        toastOptions={{
          style: {
            borderRadius: "10px",
            padding: "12px 16px",
            background: "#1e293b", // deep navy gray
            color: "#ffffffff",         // white text
            fontSize: "15px",
            fontWeight: 500,
            boxShadow: "0 0 20px rgba(0,0,0,0.3)",
          },}} />
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/login' element={<Login/>}/>
        <Route path='/myprofile' element={<MyProfile/>}/>
        <Route path='/bus-booking' element={<BusBooking/>}/>
         <Route path='/bus-details' element={<BusDetails/>}/>
        <Route path='/payment' element={<Payment/>}/>
        <Route path='/privacypolicy' element={<Privacy_policy/>}/>
        <Route path='/termscondition' element={<Termscondition/>}/>
        <Route path='/ticket/:id' element={<Tickit/>}/>
      </Routes>
      </Provider>
    </div>
  );
}

export default App;
